// extracted by mini-css-extract-plugin
export var statItem = "_ke-1";
export var statsRow = "_ke-0";